import styled from 'styled-components'

export const LinkBase = styled.a`
  text-decoration: none;
`
